import { render, staticRenderFns } from "./DosyaRaporlamaTipleriView.vue?vue&type=template&id=e8160344"
import script from "./DosyaRaporlamaTipleriView.vue?vue&type=script&lang=ts"
export * from "./DosyaRaporlamaTipleriView.vue?vue&type=script&lang=ts"
import style0 from "./DosyaRaporlamaTipleriView.vue?vue&type=style&index=0&id=e8160344&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports